import React, { useRef } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const ALLOWED_INCOMPLETE_ROUTES = ['/subscription', '/onboarding/profile', '/onboarding/documents', '/onboarding/pending'];

const ProtectedRoute = ({ children, allowedRoles }) => {
  const { user, loading, token, getRedirectPath } = useAuth();
  const location = useLocation();
  const redirectCount = useRef(0);

  // Fallback: Check localStorage directly in case AuthContext hasn't picked up the token yet
  const localToken = localStorage.getItem('token');
  const localUserStr = localStorage.getItem('user');
  const effectiveToken = token || localToken;
  let parsedUser = null;
  try {
    parsedUser = localUserStr ? JSON.parse(localUserStr) : null;
  } catch (e) {
    localStorage.removeItem('user');
  }
  const effectiveUser = user || parsedUser;

  if (loading && !effectiveUser) {
    return (
      <div className="min-h-screen bg-dark flex items-center justify-center">
        <div className="text-gold">Loading...</div>
      </div>
    );
  }

  if (!effectiveToken || !effectiveUser) {
    const from = location.pathname + location.search;
    const loginPath = '/auth/patient/login';
    return <Navigate to={loginPath} state={{ from }} replace />;
  }

  if (allowedRoles && allowedRoles.length && !allowedRoles.includes(effectiveUser.role)) {
    const roleLogin = {
      patient: '/auth/patient/login',
      doctor: '/auth/doctor/login',
      retailer: '/auth/retailer/login',
      clinic: '/auth/clinic/login',
      hospital: '/auth/hospital/login',
      admin: '/admin/login'
    };
    const redirectTo = roleLogin[effectiveUser.role] || '/auth/patient/login';
    return <Navigate to={redirectTo} replace />;
  }

  const redirectPath = getRedirectPath(effectiveUser);
  const currentPath = location.pathname + location.search;
  const currentBase = location.pathname;

  const isRedirectTarget = currentPath === redirectPath;
  const isAllowedRoute = ALLOWED_INCOMPLETE_ROUTES.some(route => currentBase.startsWith(route));
  const isDashboardOrHome = redirectPath.includes('/dashboard') || redirectPath.includes('/home');

  if (!isRedirectTarget && !isDashboardOrHome && !isAllowedRoute) {
    redirectCount.current += 1;
    if (redirectCount.current > 5) {
      return children;
    }
    return <Navigate to={redirectPath} replace />;
  }

  if (effectiveUser.role === 'doctor' && !effectiveUser.profile_image && !currentBase.includes('/dashboard/doctor/profile') && !currentBase.includes('/onboarding/profile')) {
    return <Navigate to="/onboarding/profile" replace />;
  }

  return children;
};

export default ProtectedRoute;
